<template>
  <div class="editorTool">
    <Tips :content="content" />
    <Pedesta
      v-if="pedestalId"
      :template-show-data="TmpData"
      :pedestal-id="pedestalId"
      @getPedestaData="getPedestaData"
      @changeContent="changeContent"
    />
  </div>
</template>

<script>
import {
  getPagesTemplateDetail,
  savePagesTemplate,
  getPagesTemplateList
} from '@/api/weappTmpApis/editorFormTool'
import Pedesta, { registerPedestal } from '@/view/weappTmp/index.vue'
import Tips from './tips'
import newTest from '@/view/weappTmp/test/newTest1.json'
export default {
  components: {
    Pedesta,
    Tips
  },
  props: {
    relStore: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      // 基座配置项
      pedestalId: '',
      TmpData: {},
      content:
        '拖拽左侧组件至中间区域创建表单页内容，中间可拖动区域的表单区域可上下拖动表单项，调整表单项填写顺序。'
    }
  },
  destroyed () {
    console.log('父级', this.pedestalId, '实例销毁')
  },
  created () {
    const query = this.$route.query
    if (query.template_id && query.template_id !== '0') {
      this.getTmpData(query.template_id)
    } else {
      this.initEditorTool()
    }
  },
  mounted () {
    getPagesTemplateList()
  },
  methods: {
    // 初始化注册 模版装修器基座
    initEditorTool () {
      const formPageConfig = Object.create(require('./editorFormToolConfig/formPageConfig.js').config),
      formUniversalConfig = Object.create(require('./editorFormToolConfig/formUniversalConfig.js').config),
      formItemConfig = Object.create(require('./editorFormToolConfig/formItemConfig.js').config);

      // formPageConfig.data = {}
      // formUniversalConfig.data = {}
      // formItemConfig.data = {}
      this.pedestalId = registerPedestal({
        type: 'formTmps',
        title: '表单',
        name: 'formWeappTmp',
        homeConfig: true,
        notCompList: ['SpSelect', 'SpTest',  'SpSubdata', 'SpTextarea', 'SpTmp'],
        customConfigList:[
          {
            title:'表单配置',
            custom:{
              // 表单页面配置
              formPageConfig,
              // 表单通用配置
              formUniversalConfig,
              // 表单项通用配置
              formItemConfig,
              // 表单协议配置
              // formProtocolConfig:require('./editorFormToolConfig/formProtocolConfig.js').config,          
            }
          }
          
        ]
      })
      console.log('初始化注册 :this.pedestalId', this.pedestalId)
      console.log('initEditorTool',formPageConfig.data)
    },
    getPedestaData (data) {
      console.log('保存表单：getPedestaData', data)
      this.saveTmpData(data)
    },
    async saveTmpData (content) {
      const query = this.$route.query
      let filter = {
        distributor_id: this.relStore.id,
        template_name: (content.homeConfig && content.homeConfig.formPageConfig.title) || '页面名称',
        content: JSON.stringify({
          content: { ...content }
        })
      }
      if (query.template_id) {
        filter.template_id = query.template_id
      }
      const data = await savePagesTemplate(filter)
      if (data) {
        this.$message({
          message: '保存成功',
          type: 'success',
          onClose: () => {
            this.$emit('saved', false)
            this.$router.push({
              path: '/drainage/formTemplate'
            })
          }
        })
      }
    },
    async getTmpData (template_id) {
      // getPagesTemplateDetail
      // this.TmpData = newTest
      const data = await getPagesTemplateDetail({
        template_id
      })
      if (data && data.content) {
        this.TmpData = JSON.parse(data.content)
        if (this.TmpData.content.homeConfig) {
          this.TmpData.content.homeConfig.formPageConfig.title = data.template_name || ''
        }
        console.log(this.TmpData, 'this.TmpData')
      }
      this.initEditorTool()
    },
    changeContent (data) {
      if (data === 'formConfig') {
        this.content = '点击左侧配置项，在右侧区域配置相关通用配置。'
      } else {
        this.content =
          '拖拽左侧组件至中间区域创建表单页内容，中间可拖动区域的表单区域可上下拖动表单项，调整表单项填写顺序。'
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
